import posthog from 'posthog-js';

type EventName =
  | 'app_booted'
  | 'drink_logged'
  | 'invite_opened'
  | 'user_signed_up'
  | 'user_signed_in'
  | 'milestone_unlocked'
  | 'demo_viewed';

let initialized = false;

export function initTelemetry() {
  if (initialized) return;
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;
  try {
    posthog.init(key, {
      api_host: 'https://eu.posthog.com',
      autocapture: false,
      capture_pageview: false,
      disable_session_recording: true,
      session_recording: { maskAllInputs: true },
    });
    initialized = true;
  } catch {
    // Telemetry must never break the app
  }
}

export function track(event: EventName, properties?: Record<string, unknown>) {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch {
    // swallow
  }
}

export function identifyUser(userId: string) {
  if (!initialized) return;
  try {
    posthog.identify(userId);
  } catch {
    // swallow
  }
}

export function resetTelemetry() {
  if (!initialized) return;
  try {
    posthog.reset();
  } catch {
    // swallow
  }
}